<script>
  import Icon from "./helpers/Icon.svelte";
  import AdPlayer from "./UI.Ad.Player.svelte";
  import copy from "../data/doc.json";
  import fx from "../actions/fx.js";
  import { audioActive, adOpen, audienceOpen } from "../stores/global.js";
  let activeOption = 0;
  let open;

  const options = copy.adOptions.map((d) => ({
    ...d,
    slug: d.name.toLowerCase().replace(/\W/g, ""),
  }));

  const toggle = () => {
    $adOpen = !$adOpen;
    if (!$adOpen) $audioActive = null;
  };

  const updateActive = (i) => {
    activeOption = i;
    $audioActive = null;
  };
</script>

<div id="ad" class:open="{$adOpen}" class:hide="{$audienceOpen}">
  <div class="inner">
    <p class="title">{copy.adOverline}</p>
    <div class="options">
      {#each options as { name }, i}
        <div class="option" class:active="{i === activeOption}">
          <button on:click="{() => updateActive(i)}">{name}</button>
        </div>
      {/each}
    </div>
    <div class="info">
      {#each options as { slug, description, highlight, audio, footnote }, i}
        <div class:active="{i === activeOption}" class="item">
          <div class="left">
            <div class="audio">
              <p class="pretext">{copy.adSizzle}</p>
              {#each audio as name}
                <div class="sizzle">
                  <AdPlayer name="{name}" />
                  <label for="{name}">{name}</label>
                </div>
              {/each}
            </div>
            <p class="description">{@html description}</p>
            {#if footnote}
              <p class="footnote">{footnote}</p>
            {/if}
          </div>
          <div class="highlight">{@html highlight}</div>
        </div>
      {/each}
    </div>
  </div>
  <div class="outer">
    <button class="show icon" on:click="{toggle}" use:fx
      >{copy.adTease}
      <span><Icon stroke-width="1px" name="volume-2" /></span></button
    >
    <button class="hide icon" on:click="{toggle}" use:fx
      ><span><Icon stroke-width="1px" name="x" /></span></button
    >
  </div>
</div>

<style>
  #ad {
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: auto;
    transform: translate(0, 100%);
    transition: transform 250ms ease-out;
    z-index: var(--z-top);
  }

  #ad.open {
    transform: translate(0, 0);
  }

  #ad.hide button.show {
    opacity: 0;
    pointer-events: none;
  }

  .options {
    display: flex;
    justify-content: space-evenly;
    background-color: var(--base-gray-dark);
    padding: 1em 0;
  }

  .option {
    display: flex;
    align-items: center;
    flex-direction: column;
    align-items: center;
  }

  p.title {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    position: absolute;
    top: 0;
    left: 1em;
    margin: 0;
    transform: translate(0, 0);
    transition: all 250ms ease-out;
  }

  .open p.title {
    transform: translate(0, -150%);
  }

  button {
    margin: 0;
    line-height: 1.2;
    display: flex;
    padding: 0.5em;
    border: 1px dashed currentColor;
    font-size: 12px;
    font-weight: bold;
    color: var(--base-white);
    transition: all 150ms ease-out;
    text-align: center;
    border-radius: 0;
    opacity: 0.75;
    max-width: 14em;
    text-transform: uppercase;
  }

  .active button {
    color: var(--theme);
    opacity: 1;
  }

  .inner {
    background-color: var(--base-white);
    width: 30em;
    /* box-shadow: 0 0 5px 10px rgba(0, 0, 0, 0.75); */
  }

  .outer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  button.show {
    position: absolute;
    bottom: 100%;
    left: 1em;
    pointer-events: auto;
    border: 1px dashed var(--base-white);
    border-radius: 0;
    width: 8em;
    height: 8em;
    font-size: 12px;
    font-weight: bold;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    padding-top: 1em;
    transition: all 250ms ease-out;
    transform: translate(0, -1em);
  }

  button.hide {
    position: absolute;
    bottom: 100%;
    right: 0;
    pointer-events: auto;
    border: 1px dashed var(--base-white);
    border-radius: 0;
    font-size: 12px;
    font-weight: bold;
    border-radius: 50%;
    width: 3em;
    height: 3em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    opacity: 0;
    pointer-events: none;
    transition: all 250ms ease-out;
    transform: translate(0, -1em);
  }

  button.hide span {
    transform: translate(0, 2px);
  }

  button span {
    display: block;
    margin: 0;
    line-height: 1;
    font-size: 2em;
    transform: translate(0, 4px);
  }

  .open .show {
    opacity: 0;
    pointer-events: none;
  }

  .open .hide {
    opacity: 1;
    pointer-events: auto;
  }

  .info {
    position: relative;
    height: 9em;
    color: var(--base-black);
    font-size: 16px;
  }

  .item {
    position: absolute;
    top: 0;
    left: 0;
    display: none;
    width: 100%;
    padding: 1em;
    pointer-events: none;
  }

  .item.active {
    display: flex;
    pointer-events: auto;
  }

  .left {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .left > * {
    width: 100%;
  }

  .audio {
    display: flex;
    width: 100%;
    align-items: center;
  }

  .pretext {
    font-weight: bold;
    font-size: 12px;
    color: var(--base-gray-medium);
    margin: 0;
    margin-right: 1em;
  }

  .sizzle {
    display: flex;
    align-items: center;
    margin-right: 1em;
  }

  .sizzle label {
    margin-left: 0.5em;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.2;
  }

  .description {
    margin: 0;
    margin-top: 0.5em;
  }

  .highlight {
    background-color: var(--theme);
    width: 7em;
    height: 7em;
    text-align: center;
    font-weight: bold;
    line-height: 1;
    border-radius: 50%;
    flex: 0 0 7em;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .footnote {
    font-size: 12px;
    font-style: italic;
  }

  @media only screen and (max-width: 640px) {
    #ad {
      width: 100%;
    }

    .info {
      height: auto;
    }

    .inner {
      width: 100%;
    }

    .options {
      flex-direction: column;
    }

    .option {
      margin-bottom: 1em;
    }

    button {
      max-width: 100%;
    }

    button.hide {
      right: 1em;
    }

    .item.active {
      flex-direction: column;
      position: relative;
      padding-top: 0.5em;
    }

    .highlight {
      order: 0;
      background: none;
      width: auto;
      height: auto;
      flex: 0 0 5em;
      color: var(--theme);
    }

    .left {
      order: 1;
    }

    .audio {
      order: 1;
      margin-top: 1em;
    }

    button.show {
      /* bottom: auto; */
      transform: translate(0, -40%);
      left: 2.5em;
    }
  }
</style>
